const PHOTOS_KEY_PREFIX = 'unmak_siparis_draft_photos_v1';
const LEGACY_PHOTOS_KEY = PHOTOS_KEY_PREFIX;

function photosKey(taslakTip) {
  if (!taslakTip || taslakTip === 'siparis') return LEGACY_PHOTOS_KEY;
  return `${PHOTOS_KEY_PREFIX}_${taslakTip}`;
}

function readFileAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function dataUrlToBlob(dataUrl) {
  const [header, b64] = dataUrl.split(',');
  const mime = header.match(/:(.*?);/)?.[1] || 'image/jpeg';
  const binary = atob(b64);
  const arr = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) arr[i] = binary.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

export function loadSiparisDraftPhotosRaw(taslakTip) {
  try {
    const raw = localStorage.getItem(photosKey(taslakTip));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export async function persistSiparisDraftPhotos(items, taslakTip) {
  const key = photosKey(taslakTip);
  if (!items?.length) {
    localStorage.removeItem(key);
    return;
  }
  const stored = [];
  for (const item of items.slice(0, 8)) {
    if (!item?.file) continue;
    try {
      const dataUrl = await readFileAsDataUrl(item.file);
      stored.push({
        name: item.file.name || 'foto.jpg',
        type: item.file.type || 'image/jpeg',
        dataUrl,
      });
    } catch {
      /* skip */
    }
  }
  if (stored.length) {
    localStorage.setItem(key, JSON.stringify(stored));
  } else {
    localStorage.removeItem(key);
  }
}

export function clearSiparisDraftPhotos(taslakTip) {
  localStorage.removeItem(photosKey(taslakTip));
}

export async function restoreSiparisDraftPhotos(taslakTip) {
  const stored = loadSiparisDraftPhotosRaw(taslakTip);
  const out = [];
  for (const s of stored) {
    if (!s?.dataUrl) continue;
    try {
      const blob = dataUrlToBlob(s.dataUrl);
      const file = new File([blob], s.name || 'foto.jpg', { type: s.type || 'image/jpeg' });
      out.push({ file, previewUrl: URL.createObjectURL(file) });
    } catch {
      /* skip */
    }
  }
  return out;
}
